import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DownloadAuthenticateReceiptComponent } from './download-authenticate-receipt/download-authenticate-receipt.component';
import { DownloadLargeReceiptComponent } from './download-large-receipt/download-large-receipt.component';
import { ReceiptAuthenticationComponent } from './receipt-authentication/receipt-authentication.component';
import { ReceiptauthenticationsuccessComponent} from './receiptauthenticationsuccess/receiptauthenticationsuccess.component';
import { NgxFileDropModule } from 'ngx-file-drop';
import { SenderdetailsResolver} from '../app/Resolver/senderdetails.resolver';
import { MessagedetailsResolver} from '../app/Resolver/messagedetails.resolver';
import { MessagedetailsbyshistoryResolver } from '../app/Resolver/messagedetailsbyshistory.resolver';
import {AuthenticatedReceiptDownloadDetailsResolver} from '../app/Resolver/authenticated-receipt-download-details.resolver';
import { HomepageComponent } from './homepage/homepage.component';
import { ErrorpageComponent } from './errorpage/errorpage.component'
import { AppComponent } from './app.component';

const routes: Routes = [
  {path: '', component: HomepageComponent, pathMatch: 'full'},
  {path:':messageId', component: AppComponent},
  { path: 'receipt-authentication', 
    component: ReceiptAuthenticationComponent,
    data: {title: 'Receipt Authentication'}
  },
  { path: 'receipt-authentication/:messageId', 
    component: ReceiptAuthenticationComponent,
    data: {title: 'Receipt Authentication'},
    resolve: { senderDetails: SenderdetailsResolver}
    
  },
  { path: 'download-authenticated-receipt', 
    component: DownloadAuthenticateReceiptComponent,
    data: {title: 'Receipt Authentication Retrieval'}
  },
  { path: 'download-authenticated-receipt/:historyId', 
    component: DownloadAuthenticateReceiptComponent,
    data: {title: 'Receipt Authentication Retrieval'},
    resolve: { messageDetailsByHistoryId: MessagedetailsbyshistoryResolver,
               authenticatedReceiptDownloadDetails: AuthenticatedReceiptDownloadDetailsResolver
             } 
  },
  { path: 'receipts/retrieve', 
    component: DownloadLargeReceiptComponent,
    data: {title: 'Large Receipt Retrieval'}

  },
  { path: 'receipts/retrieve/:messageId', 
    component: DownloadLargeReceiptComponent,
    data: {title: 'Large Receipt Retrieval'},
    resolve: { messageDetails: MessagedetailsResolver }

  },
  { path:'receipt-authentication-success', component:ReceiptauthenticationsuccessComponent}
  ,
  { path:'homepage', component:HomepageComponent},
  { path:'errorpage/:errorDesc', component:ErrorpageComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false }),
    NgxFileDropModule],
  exports: [RouterModule]
})
export class AppRoutingModule { }
